import {css} from 'styled-components'

export default css`
> .title {
  font-size: 2.25rem;

  text-align: center;
  margin-bottom: 2rem;
}

> .subTitle {
  text-align: center;
  margin-bottom: 3.5rem;
}

&.hasTitle > .Sections {
  margin-top: 3.5rem;
}

&.grid > .Sections,
&.imageGrid > .Sections {
  display: flex;
  flex-wrap: wrap;
  margin-top: 2rem;

  > * {
    flex: 1 0 100%;
    padding: 0.5rem;

    @media (min-width: 770px) {
      flex: 1 0 100%;
      flex: 1 0 33%;
    }
  }
}

&.fullWidth {
  display: flex;
  width: 100%;

  > .Sections {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    > * {
      flex: 1 0 33%;
      padding: 0.5rem 1rem;
      align-self: baseline;

      @media (min-width: 770px) {
        flex: 1 0;
      }
    }

    > .MediaObject > img {
      width: 100%;
    }
  }
}

&.gridTwoColumns,
&.gridThreeColumns,
&.gridFourColumns,
&.gridFiveColumns,
&.gridSixColumns {
  > .Sections {
    display: grid;
    gap: 2rem;
  }
}

@media (max-width: 770px) {
  &.gridTwoColumns,
  &.gridThreeColumns,
  &.gridFourColumns,
  &.gridFiveColumns,
  &.gridSixColumns {
    > .Sections {
      grid-template-columns: repeat(1, minmax(0, 1fr));;
    }
  }
}

@media (max-width: 960px) and (min-width: 770px) {
  &.gridTwoColumns > .Sections {
    grid-template-columns: repeat(1, minmax(0, 1fr));;
  }
  &.gridThreeColumns > .Sections {
    grid-template-columns: repeat(1, minmax(0, 1fr));;
  }
  &.gridFourColumns > .Sections {
    grid-template-columns: repeat(2, minmax(0, 1fr));;
  }
  &.gridFiveColumns > .Sections {
    grid-template-columns: repeat(3, minmax(0, 1fr));;
  }
  &.gridSixColumns > .Sections {
    grid-template-columns: repeat(3, minmax(0, 1fr));;
  }
}

@media (min-width: 960px) {
  &.gridTwoColumns > .Sections {
    grid-template-columns: repeat(2, minmax(0, 1fr));;
  }
  &.gridThreeColumns > .Sections {
    grid-template-columns: repeat(3, minmax(0, 1fr));;
  }
  &.gridFourColumns > .Sections {
    grid-template-columns: repeat(4, minmax(0, 1fr));;
  }
  &.gridFiveColumns > .Sections {
    grid-template-columns: repeat(5, minmax(0, 1fr));;
  }
  &.gridSixColumns > .Sections {
    grid-template-columns: repeat(6, minmax(0, 1fr));;
  }
}
`
